import React from "react";
import "../products/product.css";
import CreateBtn from "../../components/buttons/createBtn";
import searcher from "../../assets/searchInput.svg";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import DivisionTable from "./divisionTable";

const DivisionList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const status = queryParamsData.get("status") ?? "";
  const search = queryParamsData.get("search") ?? "";

  const user_type = localStorage.getItem("userType");

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    { path: "/division", breadcrumb: " / division" },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  const queryParams = [];
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      {user_type === "vendor" && (
        <div className="products-page">
          <div className="products-main-div">
            <div className="mx-3">
              {breadcrumbs.map(({ match, breadcrumb }) => (
                <NavLink
                  key={match.pathname}
                  to={match.pathname}
                  className="header-route-page fw_400 cursor_pointer"
                >
                  <span className="fs_18">{breadcrumb}</span>
                </NavLink>
              ))}
            </div>
            <div className="products-main-list my-2 py-1 d-flex justify-content-between flex-column">
              <div className="">
                <div className="search-container d-flex justify-content-between align-items-center">
                  <div className="search-box d-flex align-items-center p-2 ms-3 m-1 mb-2">
                    <img
                      className="styled-SVG"
                      src={searcher}
                      color={""}
                      alt="0"
                    />
                    <input
                      value={search}
                      className="search-input fw_400 px-2 text-dark"
                      type="text"
                      placeholder="Search Divisions here by Division ID, Division Name..."
                      onChange={(e) => {
                        navigate(
                          `/division?page=1${
                            e.target.value ? `&search=${e.target.value}` : ""
                          }${queryString}`
                        );
                      }}
                    />
                  </div>

                  <div className=" d-flex justify-content-between m-1 mb-2">
                    <button
                      onClick={() => navigate(`/division`)}
                      className="py-1 border-0 rounded-2 mx-2 px-3 fs_14 Medium_Purple"
                    >
                      Clear Filters
                    </button>
                    <CreateBtn link="/division/create" />
                  </div>
                </div>
                <DivisionTable
                  search={search}
                  status={status}
                  page_no={page_no}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DivisionList;
